import React, { useState } from 'react'
import BigModal from '../../../components/Modals/BigModal'
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import API from '../../../services/API'
import { Close } from '@mui/icons-material'

const AddNewWardDepartment = ({ open, onClose, afterAdd, organisation }) => {
  const [ward, setWard] = useState({})
  // TODO: Switch to useMemo to allow ward details to be saved if cancelled

  const [uploadError, setUploadError] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    setUploadError(false)
    API.post('/pts/newwarddepartment', {
      ...ward,
      organisation: organisation._id,
    })
      .then((res) => {
        if (res.status === 200 && res.data?._id) {
          afterAdd(res.data)
          setWard({})
          onClose()
        } else {
          setUploadError(true)
        }
      })
      .catch(() => setUploadError(true))
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      component="form"
      onSubmit={handleSubmit}
    >
      <DialogTitle>
        Add a new Ward/Department to {organisation?.orgName}
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={1} autoComplete="off">
          {uploadError && (
            <Alert severity="error" onClose={() => setUploadError(false)}>
              Could not save this ward/department. Please try again, or contact
              a PTS Co-Ordinator if the problem continues.
            </Alert>
          )}
          <TextField
            fullWidth
            value={ward?.name ?? ''}
            onChange={(e) =>
              setWard((prev) => ({
                ...prev,
                name: e.target.value,
              }))
            }
            label="Department Name"
            placeholder="i.e. Ward 3"
            required
          />
          <Autocomplete
            value={ward?.type ?? ''}
            inputValue={ward?.type ?? ''}
            onChange={(e, newValue) =>
              setWard((prev) => ({
                ...prev,
                type: newValue ?? '',
              }))
            }
            onInputChange={(e, newValue) =>
              setWard((prev) => ({
                ...prev,
                type: newValue,
              }))
            }
            options={['Ward', 'Emergency Department', 'Discharge Lounge']}
            renderInput={(params) => (
              <TextField {...params} label="Type" required />
            )}
            freeSolo
            fullWidth
          />
          <TextField
            value={ward?.internalLocation ?? ''}
            onChange={(e) =>
              setWard((prev) => ({
                ...prev,
                internalLocation: e.target.value,
              }))
            }
            label="Internal Location"
            placeholder="i.e. East Corridor Level 3"
            fullWidth
          />
          <TextField
            value={ward?.contactName ?? ''}
            onChange={(e) =>
              setWard((prev) => ({
                ...prev,
                contactName: e.target.value,
              }))
            }
            label="Contact Name"
            autoComplete="off"
            fullWidth
          />
          <TextField
            value={ward?.contactPhone ?? ''}
            onChange={(e) =>
              setWard((prev) => ({
                ...prev,
                contactPhone: e.target.value,
              }))
            }
            label="Contact Phone"
            autoComplete="off"
            fullWidth
          />
          <TextField
            value={ward?.contactEmail ?? ''}
            onChange={(e) =>
              setWard((prev) => ({
                ...prev,
                contactEmail: e.target.value,
              }))
            }
            label="Contact Email"
            fullWidth
            autoComplete="off"
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          color="error"
          onClick={() => onClose()}
          variant="outlined"
          startIcon={<Close />}
        >
          Close
        </Button>
        <Button color="success" type="submit" variant="contained">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AddNewWardDepartment
